import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2ca774d1&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=2ca774d1&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca774d1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\aihuz\\arbitration-ui\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ca774d1')) {
      api.createRecord('2ca774d1', component.options)
    } else {
      api.reload('2ca774d1', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=2ca774d1&scoped=true&", function () {
      api.rerender('2ca774d1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/compose/selectArb/index.vue"
export default component.exports